import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Buttons';

const CloseButton = ({ children, intlId, ...rest }) => (
  <Button {...rest}>
    {children || <FormattedMessage id={intlId || 'CloseButton-label-close'} defaultMessage="Close" />}
  </Button>
);

export default CloseButton;
